import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'primereact/resources/themes/lara-light-blue/theme.css'
import '../../styles/global.css';
import '../../styles/pages/CadastroFarm.css';
import Auth from '../../auth/Authenticator';
import '@geoman-io/leaflet-geoman-free'
import * as L from 'leaflet'
import * as mapas from '../../utils/mapas';
import { Dropdown } from 'primereact/dropdown';
import API from '../../api/API';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Avatar } from 'primereact/avatar';
import { errorMessage } from '../../utils/messages';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputSwitch, InputSwitchChangeEvent } from 'primereact/inputswitch';
import { Image } from 'primereact/image';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ImovelType, newImovel, PessoaType, PropriedadeSearchType } from '../../db/Orm';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primereact/autocomplete';
import { InputMask } from 'primereact/inputmask';
import * as turf from '@turf/turf'
import DocumentFileUpload from '../components/DocumentFileUpload';

type Props = {
    visible: boolean
    setVisible: Function
    imovel: ImovelType
    setImovel: Function
    pessoas: Array<PessoaType>
    municipios: Array<any>
    edit: boolean
    abrirSearchPropriedade: (nome:string)=>void
}

export default function CadastroImovel(props: Props) {
    const [mapa, setMapas] = useState<L.Map | null>(null)
    const [editableMapa, setEditableMapa] = useState<L.Map | null>(null)
    const [loteMapa, setLoteMapa] = useState<L.Map | null>(null)
    const mapRef = useRef<any>(null);
    const editableMapRef = useRef<any>(null);
    const loteMapRef = useRef<any>(null);
    const [poligonosCarMap, setPoligonosCarMap] = useState<mapas.AllType>()
    const [poligonosEditableMap, setPoligonosEditableMap] = useState<any>()
    const [poligonoLote, setPoligonoLote] = useState<any>()
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true)
    const [car, setCar] = useState<L.Layer | L.GeoJSON | null>()
    const [editablePoligono, setEditablePoligono] = useState<any>()
    const [cars, setCars] = useState<Array<mapas.CAR>>([])
    const [waiting, setWaiting] = useState<boolean>(false)
    const [lotePopup, setLotePopup] = useState<any>()
    const cadastradoRef = useRef<PropriedadeSearchType|null>(null)

    const selectCar2 = (car: L.GeoJSON, cars: Array<mapas.CAR>) => {
        cars.map((p) => { p.poligono.setStyle(mapas.estiloArea) })
        car.setStyle(mapas.estiloSelected)
        car.openPopup()
    }
    const selectCar = (car: L.GeoJSON, cars: Array<any>) => {
        cars.map((p) => { p.setStyle(mapas.estiloArea) })
        car.setStyle(mapas.estiloSelected)
        car.openPopup()
    }
    useEffect(() => {
        console.log(car)
        setLotePopup(car?.getPopup()?.getContent())
        props.setImovel({ ...props.imovel, poligono: car })
    }, [car])
    useEffect(() => {
        if (editablePoligono === null) return
        //console.log('editablePoligono', editablePoligono)
        setLotePopup(editablePoligono?.getPopup?.()?.getContent())
        props.setImovel({ ...props.imovel, poligono: null })
        setTimeout(() => props.setImovel({ ...props.imovel, poligono: editablePoligono }), 100)
        // if (lotePolygonOld && lotePolygonOld !== editablePoligono) {
        //     lotePolygonOld?.remove()
        // }
        editableMapa?.eachLayer(l=>{
            if (!(l instanceof L.Path)) return
            if (!((l instanceof L.Polygon)||(l instanceof L.Circle))) return
            if (l.options.color === mapas.estiloContorno.color) return
            if (l !== editablePoligono) l.remove()
        })
        setLotePolygonOld(editablePoligono)
    }, [editablePoligono])
    useEffect(() => {
        //console.log('Alterando poligono do Imovel')
        let polygon: L.Polygon | undefined
        //console.log('Props imovel', props.imovel)
        if (props.imovel.poligono) {

            if (props.imovel.poligono.eachLayer)
                props.imovel.poligono.eachLayer((p: any) => {
                    if (p instanceof L.Polygon) {
                        const latLngs = p.getLatLngs()
                        polygon = L.polygon(latLngs as L.LatLngExpression[])
                    }
                })
            else
                polygon = L.polygon(props.imovel.poligono.getLatLngs())
        }

        if (polygon) {
            poligonoLote?.remove()
            setPoligonoLote(polygon)
        } else {
            // console.log('Nenhum poligono encontrado no GeoJSON')
        }
    }, [props.imovel.poligono])
    useEffect(() => {
        if (poligonoLote) {
            loteMapa?.invalidateSize();
            poligonoLote.addTo(loteMapa)
            poligonoLote.bindPopup(lotePopup)
            poligonoLote.setStyle(mapas.estiloContorno)
            loteMapa?.fitBounds(poligonoLote.getBounds())
        }
    }, [poligonoLote])
    const [useCar, setUseCar] = useState<boolean>(true)
    const enum PERIMETER_LABEL {
        SICAR = 'Selecione o perímetro correspondente ao imóvel.',
        DRAW = 'Desenhe o perímetro do imóvel no mapa.',
        ERROR = 'Altere o município do imóvel.'
    }
    useEffect(() => {
        //console.log(`Effect usecar`)
        mapa?.invalidateSize();
        if (poligonosCarMap && poligonosCarMap.municipio)
            mapa?.fitBounds(poligonosCarMap.municipio.getBounds())
        editableMapa?.invalidateSize();
        if (poligonosEditableMap)
            editableMapa?.fitBounds(poligonosEditableMap.getBounds())
        // Resetar mapas ao ativar/desativar seleção de CAR
        mapas.clearMap(loteMapa)
        setPoligonoLote(null)
        props.imovel.poligono = null
        // Reseta mapa de seleção de CAR - "mapa"
        if (car && 'setStyle' in car)
            car.setStyle(mapas.estiloArea)
        mapa?.closePopup()
        setCar(undefined)
        // Reseta mapa de desenhar poligono da propriedade - "editableMapa"
        //console.log('editablePoligono', editablePoligono)
        if (editablePoligono)
            editableMapa?.removeLayer(editablePoligono)
        setEditablePoligono(null)
        setLotePolygons([])
    }, [useCar])
    const carregarMunicipio = async (municipio: any) => {
        if (municipio) {
            poligonosCarMap?.municipio?.remove()
            try{
                poligonosCarMap?.cars.map((p: any) => p.remove())
            }
            catch(e){
                console.log('Error ao remover cars:', e)
            }
            poligonosEditableMap?.remove()
            const psCarMap = await mapas.loadMunicipioCars(mapa, municipio, mapas.estiloContorno, true, true, navigate, selectCar, setCar, setCars)
            const psEditableMap = await mapas.loadMunicipio(editableMapa, municipio, mapas.estiloContorno, true)
            if (psCarMap) {
                setPoligonosCarMap(psCarMap)
                psCarMap.municipio?.openPopup()
                // console.log('Bounds of psCarMap.municipio:', psCarMap.municipio?.getBounds());
            }
            if (psEditableMap) {
                setPoligonosEditableMap(psEditableMap)
                psEditableMap.openPopup()
                // console.log('Bounds of psEditableMap:', psEditableMap.getBounds());
            }
            setUseCar(false)
            setUseCar(true)
            // Add a small delay for invalidateSize to work correctly
            setTimeout(() => {
                mapa?.invalidateSize();
                if (psCarMap && psCarMap.municipio)
                    mapa?.fitBounds(psCarMap.municipio.getBounds());
                editableMapa?.invalidateSize();
                if (poligonosEditableMap)
                    editableMapa?.fitBounds(poligonosEditableMap.getBounds());
            }, 100);
        }
    }

    function changeField(event: any) {
        let { value, name } = event.target;
        if (name === 'municipio')
            setErrorMunicipio('')
        else if (name === 'nome') {
            setErrorNome('')
            value = (value as string).toUpperCase()
        }
        else if (name === 'proprietario')
            setErrorProprietario('')

        // console.log('ChangeField', name, value)
        props.setImovel({ ...props.imovel, [name]: value });

        if (name === 'municipio'){
            carregarMunicipio(value)
        }
    }

    const verificarDiferenca = () => {
        // poligonoMunicipio?.municipio?.remove()
        // var ok = false
        // mapa.eachLayer((layer: L.Layer) => {
        //     if (layer instanceof L.Polygon) {
        //         console.log('Layer em analise', layer)
        //         const turfMunicipio: any = mapas.layerToPolygon(poligonoMunicipio?.municipio?.getLayers()[0])
        //         const turfPropriedade = mapas.layerToPolygon(layer)
        //         console.log('Poligono Vazio', poligonoMunicipio)
        //         if (poligonoMunicipio) {
        //             const difference = turf.difference(turfPropriedade, turfMunicipio)
        //             if (difference) {
        //                 console.log('Propriedade com área fora do municipio')
        //                 layer.remove()
        //                 console.log('Difference', difference)
        //                 const intersect = turf.intersect(turfPropriedade, turfMunicipio)
        //                 if (intersect) {
        //                     const layerIntersect = L.geoJSON(intersect)
        //                     layerIntersect.bindPopup(`Área de ${mapas.areaInHaOf(layerIntersect)}`).addTo(mapa)
        //                 }
        //                 const layerDifference = L.geoJSON(difference, { style: { color: 'red' } })
        //                 mapa.flyToBounds(layerDifference.bindPopup(`Área de ${mapas.areaInHaOf(layerDifference)}`).addTo(mapa).getBounds())
        //                 msgs.current.show([{
        //                     stick: true,
        //                     severity: 'error',
        //                     content: (
        //                         <React.Fragment>
        //                             <div className="ml-2" style={{ paddingInlineEnd: 10 }}>Área fora de {props.imovel.municipio.nome}</div>
        //                             <Button label='Corrigir' severity='success' icon="pi pi-check" onClick={() => { layerDifference.remove(); ok = true }} />
        //                         </React.Fragment>
        //                     ),
        //                 }])
        //             } else {
        //                 console.log('Propriedade inclusa dentro do municipio')
        //                 ok = true
        //             }
        //         }
        //     }
        // })
        // return ok;
    }
    const checkLotesDentroPropriedade = (): boolean => {
        if (!props.imovel.poligono) return false;
        if (lotePolygons.length === 0) return true; // Se não há lotes, eles estão trivialmente "dentro" da propriedade

        let propertyGeoJson: turf.Feature<turf.Polygon | turf.MultiPolygon> | turf.FeatureCollection<turf.Polygon | turf.MultiPolygon>;

        // Converte o L.Layer (ou L.FeatureGroup) da propriedade para GeoJSON
        if (props.imovel.poligono instanceof L.FeatureGroup) {
            // Se for um FeatureGroup, converte para uma GeoJSON FeatureCollection
            propertyGeoJson = props.imovel.poligono.toGeoJSON() as turf.FeatureCollection<turf.Polygon | turf.MultiPolygon>;
        } else if (props.imovel.poligono instanceof L.Polygon || props.imovel.poligono instanceof L.Circle) {
            // Se for um único Polygon ou Circle, converte para uma GeoJSON Feature
            propertyGeoJson = props.imovel.poligono.toGeoJSON() as turf.Feature<turf.Polygon | turf.MultiPolygon>;
        } else {
            console.error("Tipo de polígono da propriedade não suportado para verificação de lotes.");
            return false;
        }

        // Garante que propertyGeoJson é uma FeatureCollection para iteração consistente
        let propertyFeatures: Array<turf.Feature<turf.Polygon | turf.MultiPolygon>>;
        if (propertyGeoJson.type === 'FeatureCollection') {
            propertyFeatures = propertyGeoJson.features;
        } else {
            propertyFeatures = [propertyGeoJson]; // Envolve uma única feature em um array
        }

        for (let lpol of lotePolygons) {
            let lotGeoJson: turf.Feature<turf.Polygon | turf.MultiPolygon>;

            if (lpol instanceof L.Circle) {
                const center: number[] = lpol.toGeoJSON().geometry.coordinates;
                // turf.circle retorna uma Feature de Polígono. O raio é em km para turf.circle.
                lotGeoJson = turf.circle(center, lpol.getRadius() * 0.001, { steps: 60 });
            } else if (lpol instanceof L.Polygon) {
                lotGeoJson = lpol.toGeoJSON();
            } else {
                console.error("Tipo de polígono de lote não suportado para verificação.");
                return false;
            }

            let lotIsWithinProperty = false;
            for (const propFeature of propertyFeatures) {
                if (propFeature && propFeature.geometry) {
                    try {
                        // A verificação com `turf.booleanWithin` é muito restritiva e retorna `false` 
                        // se as geometrias compartilharem uma borda.
                        // Uma abordagem mais adequada é verificar a diferença geométrica. Se a diferença
                        // entre o lote e a propriedade for nula, significa que nenhuma parte do lote
                        // está fora da propriedade, o que é o comportamento desejado.
                        const difference = turf.difference(lotGeoJson, propFeature);
                        if (difference === null) {
                            lotIsWithinProperty = true;
                            break; // O lote está dentro de pelo menos uma parte, não precisa verificar mais
                        }
                    } catch (e) {
                        console.error("Erro ao verificar booleanWithin para feature individual da propriedade:", e);
                        // Dependendo do comportamento desejado, pode-se retornar false ou logar e continuar
                    }
                }
            }
            if (!lotIsWithinProperty) {
                return false; // Se algum lote não estiver dentro da propriedade, retorna false imediatamente
            }
        }
        return true; // Todos os lotes estão dentro da propriedade
    }
    async function cadastrar(event: React.FormEvent) {
        console.log('Propriedade Poligono', props.imovel.poligono)
        console.log('Lote Poligonos', lotePolygons)
        event.preventDefault();
        if (props.imovel.nome.length < 1) {
            toast.current && toast.current.show({ severity: 'error', summary: 'Dados cadastrais', detail: 'Nome não informado!' });
            setErrorNome('* Campo obrigatório')
            nomeRef.current.focus()
            return
        } else {
            setErrorNome('')
        }
        if (!props.imovel.proprietario) {
            toast.current && toast.current.show({ severity: 'error', summary: 'Proprietário', detail: 'Proprietário não informado!' });
            setErrorProprietario('* Campo obrigatório')
            proprietarioRef.current.focus()
            return
        } else {
            setErrorProprietario('')
        }
        if (!props.imovel.municipio) {
            toast.current && toast.current.show({ severity: 'error', summary: 'Município', detail: 'Município não informado!' });
            setErrorMunicipio('* Campo obrigatório')
            municipioRef.current.focus()
            return
        } else {
            setErrorMunicipio('')
        }
        if (!props.imovel.poligono) {
            toast && toast.current && toast.current.show({ severity: 'info', summary: 'Perímetro', detail: 'Desenhe o perímetro da imovel no mapa!' });
            errorMessage(toast.current, 'Desenho o perímetro da imovel no mapa antes de continuar!')
            return
        } else {

        }
        if (!checkLotesDentroPropriedade()) {
            toast && toast.current && toast.current.show({ severity: 'error', summary: 'Perímetro', detail: 'Lotes inválidos! Todos os lotes devem estar dentro do limite da propriedade.' });
            return
        } else {

        }
        if (!docMatricula) {
            toast.current?.show({ severity: 'error', summary: 'Documento do Imóvel', detail: 'É obrigatório anexar o documento de matrícula do imóvel.' });
            return;
        }
        setWaiting(true)

        try {
            const formData = new FormData();
            formData.append('acesso', props.imovel.acesso)
            formData.append('localidade', props.imovel.localidade)
            formData.append('nome', props.imovel.nome)
            // console.log(props.imovel)
            formData.append('proprietario_id', props.imovel.proprietario.user.id)
            formData.append('municipio', props.imovel.municipio.id)
            formData.append('poligono', (await mapas.getShpZipBufferFromFeatureGroup(new L.FeatureGroup().addLayer(props.imovel.poligono as L.Polygon))) as any, props.imovel.nome + '.zip'); // Arquivo Shapefile
            if (docMatricula) {
                formData.append('doc_matricula', docMatricula);
            }
            const requestOptions = { method: 'POST', headers: Auth.getHeader(true), body: formData };
            const response = await fetch(API.url + 'propriedades/', requestOptions)
            var data = await response.json()
            if (response.ok) {
                console.log('Lote Poligonos', lotePolygons)
                var lote = 1
                lotePolygons.forEach(async (lp) => {
                    if (lp instanceof L.Polygon || lp instanceof L.Circle) {
                        const formData = new FormData()
                        const featG = new L.FeatureGroup()
                        featG.addLayer(lp)
                        formData.append('propriedade', data.id)
                        formData.append('poligono', (await mapas.getShpZipBufferFromFeatureGroup(featG)) as any, props.imovel.nome + 'lote_' + lote++ + '.zip')
                        const requestOptions = { method: 'POST', headers: Auth.getHeader(true), body: formData }
                        const response = await fetch(API.url + 'lotes/', requestOptions)
                        //console.log('Reponse cadastramento lote:', response)
                        if (response.ok) {
                            const data = await response.json()
                            //console.log(`Lote ${data.id} cadastrado com sucesso`)
                        } else {
                            console.log('Reponse error', response.status, response.statusText)
                        }
                    }

                })
                //console.log('Imovel cadastrado:', data)
                cadastradoRef.current = {id: data.id, nome: data.nome, municipio: data.municipio, status: data.status, doc_matricula: data.doc_matricula,
                    proprietario_nome: data.proprietario_nome
                }
                data.municipio = props.imovel.municipio.code
                successMessage(data)
            } else {
                console.log('Reponse error', data, response.status, response.statusText)
            }

        } catch (error: any) {
            // Lide com erros da solicitação aqui
            console.error('Erro na data:', error);
        }

        // poligonoMunicipio?.municipio?.addTo(mapa)
        // }
        setWaiting(false)
    }

    const accept = () => {
        props.setImovel(newImovel())
        mapas.clearMap(mapa)
        mapas.clearMap(editableMapa)
        mapas.clearMap(loteMapa)
        setPoligonoLote(null)
    }

    const reject = () => {
        props.setVisible(false)
        const cadastrado = cadastradoRef.current
        if (cadastrado){
            // navigate('/propriedade', { state: [cadastrado, props.municipios.filter((m: any) => m.id === cadastrado.municipio)[0]] })
            props.abrirSearchPropriedade(cadastrado.nome)
            cadastradoRef.current = null
        }
    }

    const successMessage = (imovel: ImovelType) => {
        imovel.proprietario = props.pessoas.find((p) => p.user?.id === imovel.proprietario)
        imovel.municipio = props.municipios.find((m) => m.id === imovel.municipio)
        setImoveis([...imoveis, imovel])
        confirmDialog({
            message: 'Imóvel cadastrado com sucesso de id ' + imovel.id + '!\nDeseja adicionar outro imovel?',
            header: 'Cadastro de Imóvel',
            icon: 'pi pi-exclamation-triangle',
            accept,
            reject
        });
    };
    // const loadMunicipios = async () => {
    //     setLoadingMunicipios(true)
    //     const municipios = await getMunicipios('BA')
    //     setMunicipios(municipios)
    //     setListaMunicipios(municipios.map((m: any) => { return { name: m.nome, code: m.id } }))
    //     setLoadingMunicipios(false)
    // }
    useEffect(() => {
        try {
            if (!mapRef.current) return
            const map = mapas.createMapOnBahia(mapRef)
            mapas.refreshingMap(map, setLoading)
            setMapas(map)
        } catch (e: any) { console.log('Error:', e) }
    }, [mapRef.current]);
    useEffect(() => {
        try {
            if (!editableMapRef.current) return
            const map = mapas.createMapOnBahia(editableMapRef)
            const buttonsOptions: L.PM.ToolbarOptions = {
                position: "bottomright",
                drawMarker: false,
                drawCircleMarker: false,
                drawPolygon: true,
                drawCircle: false,
                drawPolyline: false,
                drawRectangle: false,
                rotateMode: false,
                drawText: false,
            }
            mapas.editableMap(map, undefined, undefined, undefined, setEditablePoligono, true, buttonsOptions)
            mapas.refreshingMap(map, setLoading)
            setEditableMapa(map)
        } catch (e: any) { console.log('Error:', e) }
    }, [editableMapRef.current]);
    const [lotePolygon, setLotePolygon] = useState<L.Polygon | L.Circle | Array<L.Polygon | L.Circle> | null>()
    const [lotePolygonOld, setLotePolygonOld] = useState<any>()
    const [lotePolygons, setLotePolygons] = useState<Array<L.Polygon | L.Circle>>([])
    const [removePolygon, setRemovePolygon] = useState<L.Polygon | L.Circle>()
    useEffect(() => {
        if (!removePolygon) return
        setLotePolygons(lotePolygons.filter(p => p !== removePolygon))
    }, [removePolygon])
    useEffect(() => {
        if (!lotePolygon) return
        if (lotePolygon instanceof L.Polygon || lotePolygon instanceof L.Circle) {
            if (lotePolygons.includes(lotePolygon)) return
            console.log('Adicionando poligono no lote', lotePolygon)
            setLotePolygons([...lotePolygons, lotePolygon])
            return
        }
        // Neste ponto, lotePolygon é array apenas
        const newPolygons = lotePolygon.filter(lp=>!lotePolygons.includes(lp))
        console.log('Adicionando poligonos no lote', newPolygons)
        setLotePolygons([...lotePolygons, ...newPolygons])
    }, [lotePolygon])

    useEffect(() => {
        try {
            if (!loteMapRef.current) return
            const map = mapas.createMapOnBahia(loteMapRef)
            mapas.editableMap(map, undefined, undefined, undefined, setLotePolygon, false, undefined, setRemovePolygon)
            mapas.refreshingMap(map, setLoading)
            setLoteMapa(map)
            setLotePolygons([])
        } catch (e: any) { console.log('Error:', e) }
    }, [loteMapRef.current]);
    useEffect(() => {
        // loadPessoas()
        // loadMunicipios()
        setImoveis([])
        setPoligonoLote(null)
    }, [props.visible])

    const [errorNome, setErrorNome] = useState('')
    const [errorProprietario, setErrorProprietario] = useState('')
    const [errorMunicipio, setErrorMunicipio] = useState('')

    const toast = useRef<Toast | null>(null);

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <Avatar icon='pi pi-file-edit' shape="circle" />
            <span className="font-bold white-space-nowrap" style={{ width: '100%' }}> Cadastro de Imóvel</span>
        </div>
    )


    const [imoveis, setImoveis] = useState<Array<ImovelType>>([])
    const nomeRef = useRef<any>()
    const proprietarioRef = useRef<any>()
    const municipioRef = useRef<any>()
    const [findCar, setFindCar] = useState<string>()

    useEffect(() => {
        console.log('Find Car:', findCar)
        console.log('Poligonos Car Map:', poligonosCarMap)
        // const poligonoFindCar = poligonosCarMap?.cars.find((p: any) => p._popup._content.split('<br />')[0].replace('<h1>Imóvel CAR</h1><hr><b>Código: </b>', '') === findCar)
        if(findCar === undefined) return
        const poligonoFindCar = poligonosCarMap?.cars.find((p: mapas.CAR) => p.codigo.includes(findCar))
        if (poligonoFindCar) {
            setCar(poligonoFindCar.poligono)
            if (poligonosCarMap)
                selectCar2(poligonoFindCar.poligono, poligonosCarMap?.cars)
            mapa?.flyToBounds(poligonoFindCar.poligono.getBounds())
        }
    }, [findCar])

    const [filteredCars, setFilteredCars] = useState<Array<any>>([])

    const search = (event: AutoCompleteCompleteEvent) => {
        const carsList: Array<any> = []

        // poligonosCarMap?.cars.map((p: any) => carsList.push(p._popup._content.split('<br />')[0].replace('<h1>CAR</h1><hr><b>Código: </b>', '')))
        poligonosCarMap?.cars.map((p: mapas.CAR) => carsList.push(p.codigo))
        // Timeout to emulate a network connection
        setTimeout(() => {
            let _filteredCountries;

            if (!event.query.trim().length) {
                _filteredCountries = [...carsList];
            }
            else {
                _filteredCountries = carsList.filter((cr) => {
                    return cr.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCars(_filteredCountries);
        }, 250);

    }

    const [x, setX] = useState<any>(0.0)
    const [y, setY] = useState<any>(0.0)
    const [docMatricula, setDocMatricula] = useState<File | null>(null);

    return (


        <Dialog
            visible={props.visible}
            header={headerElement}
            maximizable style={{ width: '800px' }}
            onHide={() => props.setVisible(false)}
            draggable={false} resizable={false} position={'center'} modal={true} >

            <Toast ref={toast} position="bottom-right" />
            <ConfirmDialog />

            <Divider align='left'>
                <div className="inline-flex align-items-center"><i className="pi pi-user" /><b> Nome do Imóvel</b></div>
            </Divider>
            <div className="flex flex-column p-inputgroup flex-1">
                <span className="p-inputgroup-addon"><i className="pi pi-user" /></span>
                <span className="p-float-label">
                    <InputText id="username" name='nome' ref={nomeRef} value={props.imovel.nome} onChange={changeField} />
                    <label htmlFor="username">Digite o nome completo do imovel *</label>
                </span>
            </div>
            {errorNome.length > 0 && <small style={{ color: 'red', paddingInlineStart: 5 }}>{errorNome}</small>}
            <div style={{ display: 'flex', flexDirection: 'row', }}>
                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 10, width: '100%' }}>
                    <Divider align='left'>
                        <div className="inline-flex align-items-center"><i className="pi pi-map-marker" /><b> Localidade</b></div>
                    </Divider>
                    <div className="flex flex-column gap-2">
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><i className="pi pi-map-marker" /></span>
                            <span className="p-float-label">
                                <InputText id="username" name='localidade' value={props.imovel.localidade} onChange={changeField} />
                                <label htmlFor="username">Descreva a localização do imóvel</label>
                            </span>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, width: '100%' }}>
                    <Divider align='left'>
                        <div className="inline-flex align-items-center"><i className="pi pi-car" /><b> Acesso</b></div>
                    </Divider>
                    <div className="flex flex-column gap-2">
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><i className="pi pi-car" /></span>
                            <span className="p-float-label">
                                <InputText id="username" name='acesso' value={props.imovel.acesso} onChange={changeField} />
                                <label htmlFor="username">Descreva o acesso da imóvel</label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', }}>
                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 10, width: '100%' }}>
                    <Divider align='left'>
                        <div className="inline-flex align-items-center"><i className="pi pi-user" /><b> Proprietário</b></div>
                    </Divider>

                    <Dropdown ref={proprietarioRef} name='proprietario' value={props.imovel.proprietario} onChange={changeField}
                        options={props.pessoas.filter(p=>p.status==='A')} optionLabel="nome_razao" placeholder='Proprietário *' filter />
                    <small style={{ color: 'red', paddingInlineStart: 5 }}>{errorProprietario}</small>


                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, width: '100%' }}>
                    <Divider align='left'>
                        <div className="inline-flex align-items-center"><i className="pi pi-map" /><b> Município</b></div>
                    </Divider>
                    <Dropdown ref={municipioRef} name='municipio' value={props.imovel.municipio} onChange={changeField}
                        options={props.municipios} optionLabel="nome" placeholder='Município *' filter />
                    <small style={{ color: 'red', paddingInlineStart: 5 }}>{errorMunicipio}</small>


                </div>

            </div>

            {(props.imovel.municipio) ?
                <>
                    <Divider align='left'>
                        <div className="inline-flex align-items-center"><i className="pi pi-map" /><b> Perímetro do Imóvel</b></div>
                    </Divider>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div style={{ width: '100%' }}>{props.imovel.municipio ? (useCar ? PERIMETER_LABEL.SICAR : PERIMETER_LABEL.DRAW) : PERIMETER_LABEL.ERROR}</div>
                        {props.imovel.municipio ? (
                            <>
                                <Image src='https://consultapublica.car.gov.br/publico/public/images/logo_car.png' height='28' />
                                <div className="card flex justify-content-center" style={{ marginLeft: 10 }}>
                                    <InputSwitch checked={useCar} onChange={(e: InputSwitchChangeEvent) => setUseCar(e.value)} />
                                </div>
                            </>
                        ) : (<></>)}
                    </div>
                    {loading ? <ProgressBar style={{ height: 5, borderRadius: 0 }} mode='indeterminate' /> : <></>}
                </>
                : <></>}

            {props.imovel.municipio && useCar ?
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: 10, width: '100%' }}>
                        <Divider align='left'>
                            <div className="inline-flex align-items-center"><i className="pi pi-map-marker" /><b> SICAR</b></div>
                        </Divider>
                        <div className="flex flex-column gap-2">
                            <div className="flex flex-column p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-map-marker" /></span>
                                <span className="p-float-label">
                                    <AutoComplete style={{ width: '100%' }}
                                        value={findCar} suggestions={filteredCars}
                                        completeMethod={search} onChange={(e) => setFindCar(e.value)}
                                        placeholder='Se precisar, pesquise o código CAR aqui!' />
                                </span>
                            </div>
                        </div>
                    </div>
                </div> : <></>
            }
            {props.imovel.municipio && !useCar ?
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: 10, width: '100%' }}>
                        <Divider align='left'>
                            <div className="inline-flex align-items-center"><i className="pi pi-map-marker" /><b> Coordenada X</b></div>
                        </Divider>
                        <div className="flex flex-column gap-2">
                            <div className="flex flex-column p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-map-marker" /></span>
                                <span className="p-float-label">
                                    <InputMask id="coordx" name='coordx' mask='-99.999999' value={x} onChange={(e: any) => setX(e.value)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, width: '100%' }}>
                        <Divider align='left'>
                            <div className="inline-flex align-items-center"><i className="pi pi-map-marker" /><b> Coordenada Y</b></div>
                        </Divider>
                        <div className="flex flex-column gap-2">
                            <div className="flex flex-column p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-map-marker" /></span>
                                <span className="p-float-label">
                                    <InputMask id="coordy" name='coordy' mask='-99.999999' value={y} onChange={(e: any) => setY(e.value)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, width: '100%' }}>
                        <Divider align='left'>
                            <div className="inline-flex align-items-center"><i className="pi pi-search" /><b> Localizar</b></div>
                        </Divider>
                        <Button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} icon='pi pi-search' iconPos='right' onClick={() => editableMapa?.flyTo(L.latLng(x, y), 15)} label='IR' />
                    </div>
                </div> : <></>
            }

            <div ref={mapRef} style={{ width: '100%', height: props.imovel.municipio ? (useCar ? 500 : 0) : 0, backgroundColor: 'grey' }} />
            <div ref={editableMapRef} style={{ width: '100%', height: props.imovel.municipio ? (useCar ? 0 : 500) : 0, backgroundColor: 'grey' }} />


            {poligonoLote &&
                <>
                    <Divider align='left'>
                        <div className="inline-flex align-items-center"><i className="pi pi-map" /><b> Definição dos Lotes</b></div>
                    </Divider>
                </>
            }
            <div ref={loteMapRef} style={{ width: '100%', height: poligonoLote ? 500 : 0 }} />

            <br />

            <DocumentFileUpload
                label="Documento do Imóvel"
                icon={<i className="pi pi-file" />}
                initialFile={props.imovel.doc_matricula}
                onFileSelect={setDocMatricula}
                editMode={props.edit}
            />

            <br />

            <div style={{ display: 'flex', width: '100%', justifyContent: 'right' }}>
                <Button label={waiting ? '' : 'CADASTRAR'} icon={waiting ? '' : 'pi pi-send'} iconPos='right' severity="success" rounded onClick={cadastrar} >{waiting && <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />}</Button>
            </div>
            <br />
            <DataTable value={imoveis} tableStyle={{ minWidth: '50rem' }}>
                <Column field="municipio.nome" header="Município"></Column>
                <Column field="proprietario.nome_razao" header="Proprietário"></Column>
                <Column field="nome" header="Nome"></Column>
                <Column field="localidade" header="Localidade"></Column>
                {/* <Column field="acesso" header="Acesso"></Column> */}
            </DataTable>
        </Dialog>
        // </div>
    );
}
